import type { GetObligationImpactAuditByIdResponseRow } from '@risksmart-app/trpc/types';
import type { GetObligationImpactAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationImpactAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObligationImpactAuditByIdArgs = { id: string };

export const useGetObligationImpactAuditById = createQueryHook<
  UseGetObligationImpactAuditByIdArgs,
  GetObligationImpactAuditByIdResponseRow[],
  GetObligationImpactAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getObligationImpactAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ obligation_impact_audit: data }),
  graphqlDocument: GetObligationImpactAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
